import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { getSummaryState } from '../store/selectors/getSummaryState';
import changeSummaryFiltersAction from '../store/actions/changeSummaryFilters';
import ErrorBoundaryWrapper from '@gameday/components/ErrorFallback/ErrorBoundaryWrapper';
import Filters from '../Filters.js';

const actions = (dispatch) => ({
    handleFilterChange: (selected) => {
        dispatch(changeSummaryFiltersAction(selected));
    }
});

const FilterDataContainer = ({
    isFinal,
    stickyEnabled,
    scrollRef
}) => {
    const dispatch = useDispatch();

    const {
        summaryFilters,
        isLoading,
        filterKey,
        summaryFilterIndex, 
        detail
    } = useSelector(getSummaryState(isFinal));
    
    return (
        <ErrorBoundaryWrapper componentName='Summary Filters'>
            <Filters activeDetail={detail} stickyEnabled={stickyEnabled} scrollRef={scrollRef} summaryFilterIndex={summaryFilterIndex} filterKey={filterKey} isLoading={isLoading} summaryFilters={summaryFilters} { ...actions(dispatch) } />
        </ErrorBoundaryWrapper>
    );
};

FilterDataContainer.propTypes = {
    isFinal: PropTypes.bool,
    stickyEnabled: PropTypes.bool,
    scrollRef: PropTypes.object
};

export default FilterDataContainer;